import React from 'react';
import './components.css'
import resume from '../data/resume.pdf'

function NavBar(){
    return(
        <header className='site-nav'>
            <a href='#about' className='nav-wordmark'>Jennifer</a>
            <nav className='nav-center' aria-label='Primary'>
                <a href='#projects'>Projects</a>
                <a href='#publications'>Papers</a>
                <a href='#resume'>Resume</a>
            </nav>
            <nav className='nav-end' aria-label='Links'>
                <a href="https://github.com/sunwooha" target="_blank" rel="noopener noreferrer">GitHub</a>
                <a href={resume} target="_blank" rel="noopener noreferrer">CV</a>
            </nav>
        </header>
    )
}

export default NavBar;
